import { render, staticRenderFns } from "./ServiceRequestDetails.vue?vue&type=template&id=9b560898&"
import script from "./ServiceRequestDetails.vue?vue&type=script&lang=js&"
export * from "./ServiceRequestDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports